class ColorSwatcher extends HTMLElement {
  constructor() {
    super();
    this.isExpanded = false;
    this.init();
  }

  init() {
    this.colorsContainer = this.querySelector('.colors-inner');
    if (!this.colorsContainer) return;

    this.colorVariants = Array.from(this.colorsContainer.querySelectorAll('.color-variant'));
    
    this.addButton = this.colorsContainer.querySelector('img[src*="add.png"]');
    if (!this.addButton) return;

    this.setupInitialView();
    this.setupEventListeners();
  }

  setupInitialView() {
    this.colorVariants.forEach((variant, index) => {
      variant.style.display = index < 5 ? 'flex' : 'none';
    });
  }

  setupEventListeners() {
    this.addButton.addEventListener('click', () => {
      this.isExpanded = !this.isExpanded;
      this.toggleView();
      this.addButton.style.display = 'none';
    });
  }

  toggleView() {
    if (this.isExpanded) {
      this.colorVariants.forEach(variant => {
        variant.style.display = 'flex';
      });
      this.colorsContainer.style.overflowX = 'auto';
    } else {
      this.colorVariants.forEach((variant, index) => {
        variant.style.display = index < 5 ? 'flex' : 'none';
      });
      this.colorsContainer.style.overflowX = 'hidden';
    }
  }
}

if (!customElements.get('color-swatcher')) {
  customElements.define('color-swatcher', ColorSwatcher);
}
